import {
  Academy,
  Agenda,
  Application,
  Articles,
  BoxModule,
  BookAsset,
  AssetTimeslot,
  Dashboard,
  EditEmployee,
  Employee,
  MyDevelopment,
  AddForm,
  MyDevelopmentGoal,
  MyDevelopmentBlog,
  AssignGoalToTeam,
  MyOpinion,
  MyTeam,
  News,
  Onboarding,
  OnboardingQuiz,
  OnboardingTask,
  OnboardingTemplate,
  Keys,
  Settings,
  Tables,
  Vitality,
  MyDevelopmentForm,
  AddMyTeam,
  AddTeamTodo,
  Category,
  Course,
  Lesson,
  Chapter,
  AssetCategory,
  Asset,
  TodoSubmission,
  MyDevelopmentEditForm,
  FormList,
  ReadForm,
  KeyFolder,
  CalendarEvent,
  EventType,
  Report,
  Submission,
  FormBuilder,
  AddLeaveType,
  AddLeaveAllowcation,
  HR,
  LeaveSettings,
  AddHoliday,
  AddLeavePolicy,
  AddLeaveRequest,
  AddLeaveBlock,
  DocTypeRead,
} from "../pages";

export default function route() {
  return [
    {
      path: "/desktop",
      name: "Dashboard",
      key: "/desktop",
      private: true,
      element: <Dashboard />,
    },
    {
      path: "/tables",
      name: "Tables",
      key: "/tables",
      private: true,
      element: <Tables />,
    },
    {
      path: "/employees",
      name: "Employee",
      key: "/employees",
      private: true,
      element: <Employee />,
    },
    {
      path: "/news",
      name: "News",
      key: "/news",
      private: true,
      element: <News />,
    },
    {
      path: "/article",
      name: "article",
      key: "/article",
      private: true,
      element: <Articles />,
    },
    {
      path: "/application",
      name: "application",
      key: "/application",
      private: true,
      element: <Application />,
    },
    {
      path: "/my-team-list",
      name: "My Team List",
      key: "/my-team-list",
      private: true,
      element: <MyTeam />,
    },
    {
      path: "/my-opinion",
      name: "My Opinion",
      key: "/my-opinion",
      private: true,
      element: <MyOpinion />,
    },
    {
      path: "/my-development",
      name: "my-development",
      key: "/my-development",
      private: true,
      element: <MyDevelopment />,
    },
    {
      path: "/vitality",
      name: "Vitality",
      key: "/vitality",
      private: true,
      element: <Vitality />,
    },
    {
      path: "/onboarding",
      name: "Onboarding",
      key: "/onboarding",
      private: true,
      element: <Onboarding />,
    },
    {
      path: "/academy",
      name: "Academy",
      key: "/academy",
      private: true,
      element: <Academy />,
    },
    {
      path: "/box",
      name: "Box",
      key: "/box",
      private: true,
      element: <BoxModule />,
    },
    {
      path: "/book-asset",
      name: "Book Asset",
      key: "/book-asset",
      private: true,
      element: <BookAsset />,
    },
    {
      path: "/agenda",
      name: "Agenda",
      key: "/agenda",
      private: true,
      element: <Agenda />,
    },
    {
      path: "/keys",
      name: "keys",
      key: "/keys",
      private: true,
      element: <Keys />,
    },
    {
      path: "/settings",
      name: "Settings",
      key: "/settings",
      private: true,
      element: <Settings />,
    },
    {
      path: "/edit-employees/:id",
      name: "Edit Employess",
      key: "/edit-employees/:id",
      private: true,
      element: <EditEmployee />,
    },
    {
      path: "/onboarding-task",
      name: "Onboarding Task",
      key: "/onboarding-task",
      private: true,
      element: <OnboardingTask />,
    },
    {
      path: "/onboarding-quiz",
      name: "Onboarding Quiz",
      key: "/onboarding-quiz",
      private: true,
      element: <OnboardingQuiz />,
    },
    {
      path: "/onboarding-template",
      name: "Onboarding Template",
      key: "/onboarding-template",
      private: true,
      element: <OnboardingTemplate />,
    },
    {
      path: "/my-development-goal",
      name: "My Development Goal",
      key: "/my-development-goal",
      private: true,
      element: <MyDevelopmentGoal />,
    },
    {
      path: "/my-development-blog",
      name: "My Development Blog",
      key: "/my-development-blog",
      private: true,
      element: <MyDevelopmentBlog />,
    },
    {
      path: "/assign-goal-to-Team",
      name: "Assign Goal To Team",
      key: "/assign-goal-to-Team",
      private: true,
      element: <AssignGoalToTeam />,
    },
    {
      path: "/web-form",
      name: "My Development Form",
      key: "/web-form",
      private: true,
      element: <MyDevelopmentForm />,
    },
    {
      path: "/my-team",
      name: "My Team",
      key: "/my-team",
      private: true,
      element: <AddMyTeam />,
    },
    {
      path: "/team-todo",
      name: "Team Todo",
      key: "/team-todo",
      private: true,
      element: <AddTeamTodo />,
    },
    {
      path: "/category",
      name: "Category",
      key: "/category",
      private: true,
      element: <Category />,
    },
    {
      path: "/course",
      name: "Course",
      key: "/course",
      private: true,
      element: <Course />,
    },
    {
      path: "/lesson",
      name: "Lesson",
      key: "/lesson",
      private: true,
      element: <Lesson />,
    },
    {
      path: "/chapter",
      name: "Chapter",
      key: "/chapter",
      private: true,
      element: <Chapter />,
    },
    {
      path: "/add-form",
      name: "Add Form",
      key: "/add-form",
      private: true,
      element: <AddForm />,
    },
    {
      path: "/book-asset",
      name: "Book Asset",
      key: "/book-asset",
      private: true,
      element: <BookAsset />,
    },
    {
      path: "/asset-category",
      name: "Asset Category",
      key: "/asset-category",
      private: true,
      element: <AssetCategory />,
    },
    {
      path: "/asset",
      name: "Asset",
      key: "/asset",
      private: true,
      element: <Asset />,
    },
    {
      path: "/todo-submission",
      name: "Todo Submission",
      key: "/todo-submission",
      private: true,
      element: <TodoSubmission />,
    },
    {
      path: "/read-form",
      name: "Read Fprm",
      key: "/read-form",
      private: true,
      element: <ReadForm />,
    },
    {
      path: "/doc-read-form",
      name: "Read Fprm",
      key: "/doc-read-form",
      private: true,
      element: <DocTypeRead />,
    },
    {
      path: "/form-list",
      name: "Form List",
      key: "/form-list",
      private: true,
      element: <FormList />,
    },
    {
      path: "/key-folder",
      name: "Key Folder",
      key: "/key-folder",
      private: true,
      element: <KeyFolder />,
    },
    {
      path: "/calender-event",
      name: "Calender Event",
      key: "/calender-event",
      private: true,
      element: <CalendarEvent />,
    },
    {
      path: "/event-type",
      name: "Event Type",
      key: "/event-type",
      private: true,
      element: <EventType />,
    },
    {
      path: "/report",
      name: "Report",
      key: "/report",
      private: true,
      element: <Report />,
    },
    {
      path: "/submission",
      name: "Submission",
      key: "/submission",
      private: true,
      element: <Submission />,
    },
    {
      path: "/form-builder",
      name: "Form Builder",
      key: "/form-builder",
      private: true,
      element: <FormBuilder />,
    },
    {
      path: "/add-leave-type",
      name: "Add Leave Type",
      key: "/add-leave-type",
      private: true,
      element: <AddLeaveType />,
    },
    {
      path: "/add-leave-allowcation",
      name: "Add Leave Allowcation",
      key: "/add-leave-allowcation",
      private: true,
      element: <AddLeaveAllowcation />,
    },
    {
      path: "/hr",
      name: "HR",
      key: "/hr",
      private: true,
      element: <HR />,
    },
    {
      path: "/leave-settings",
      name: "Leave Settings",
      key: "/leave-settings",
      private: true,
      element: <LeaveSettings />,
    },
    {
      path: "/add-holiday",
      name: "Add Holiday",
      key: "/add-holiday",
      private: true,
      element: <AddHoliday />,
    },
    {
      path: "/add-leave-policy",
      name: "Add Holiday",
      key: "/add-leave-policy",
      private: true,
      element: <AddLeavePolicy />,
    },
    {
      path: "/new-leave-request",
      name: "Add Holiday",
      key: "/new-leave-request",
      private: true,
      element: <AddLeaveRequest />,
    },
    {
      path: "/leave-block-list",
      name: "Add Holiday",
      key: "/leave-block-list",
      private: true,
      element: <AddLeaveBlock />,
    },
  ];
}
